import { GET_CONTACT_SUCCESS } from "../constants";

const initialState = {};

export default function contactReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CONTACT_SUCCESS:
      console.log("action.payload.data", action.payload.data);

      return {
        ...state,
      };

    default:
      return state;
  }
}
